module.exports = __webpack_public_path__ + "guanao-pc/static/media/19821798128.3359aa87.jpg";